export default function AssessmentInProgressDialogController(
  ssDialogService
) {
  const vm = this;
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleOk = handleOk;

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleOk() {
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.editDepartmentDialog);
  }
}

AssessmentInProgressDialogController.$inject = [
  'ssDialogService'
];
